<template>
  <div id="app">
    <NavBar />
    <main class="app-main">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import { onMounted } from 'vue'
import NavBar from './components/layouts/NavBar.vue'
import AppFooter from './components/layouts/Footer.vue'
import { portfolioAPI } from './lib/portfolioAPI'

export default {
  name: 'App',
  components: {
    NavBar,
    AppFooter,
  },
  setup() {
    onMounted(() => {
      // Précharger les données en arrière-plan de manière non-bloquante
      setTimeout(async () => {
        try {
          console.log('🔄 Préchargement des données en arrière-plan...')
          const startTime = performance.now()
          
          const result = await portfolioAPI.preloadAll()
          
          const endTime = performance.now()
          const loadTime = Math.round(endTime - startTime)
          
          if (result.success) {
            console.log(`✅ Toutes les données préchargées en ${loadTime}ms`)
          } else {
            console.warn('⚠️ Erreur lors du préchargement:', result.error)
          }
        } catch (error) {
          console.error('❌ Erreur critique lors du préchargement:', error)
        }
      }, 100)
    })

    return {}
  }
}
</script>
